function initFeaturedProductSpotlight(sectionId) {
  var root = document.getElementById(sectionId);
  if (!root) return;

  // Thumbnail gallery swap
  var mainImage = root.querySelector('[id^="fps-main-image-"]');
  var thumbs = root.querySelectorAll('[data-thumb]');

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (!mainImage) return;
      mainImage.setAttribute('src', thumb.getAttribute('data-preview-src'));
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });

  // Quantity stepper
  var qtyInput = root.querySelector('[data-qty-input]');
  var minusBtn = root.querySelector('[data-qty-minus]');
  var plusBtn = root.querySelector('[data-qty-plus]');

  if (qtyInput && minusBtn && plusBtn) {
    minusBtn.addEventListener('click', function () {
      var value = parseInt(qtyInput.value, 10) || 1;
      qtyInput.value = Math.max(1, value - 1);
    });

    plusBtn.addEventListener('click', function () {
      var value = parseInt(qtyInput.value, 10) || 1;
      qtyInput.value = value + 1;
    });
  }
}

// Expose globally for the inline call in the section file
window.initFeaturedProductSpotlight = initFeaturedProductSpotlight;